import { Component, OnInit } from "@angular/core";
import { MenuController } from "@ionic/angular";
import { AppRoutes } from "src/app/constants";
import { Observable } from "rxjs";
import { Store } from "@ngrx/store";
import { RootState } from "src/app/store";
import * as UserActions from "src/app/store/user/actions";
import * as FromUser from "src/app/store/user/selectors";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.page.html",
  styleUrls: ["../login/login.page.scss"],
})
export class ResetPasswordPage implements OnInit {
  public loading$: Observable<boolean> = this.store.select(FromUser.selectLoading);
  public routes: typeof AppRoutes = AppRoutes;
  public showPassword: boolean;
  public form: FormGroup;
  public token: string = this.activatedRoute.snapshot.queryParamMap.get("token");
  public email: string = this.activatedRoute.snapshot.queryParamMap.get("email");

  constructor(private menu: MenuController, private store: Store<RootState>, private activatedRoute: ActivatedRoute) {
    this.menu.enable(false);
  }

  public ngOnInit(): void {
    this.store.dispatch(UserActions.reset());
    localStorage.clear();

    this.form = new FormGroup({
      email: this.token
        ? new FormControl({ value: this.email, disabled: true })
        : new FormControl(this.email, [Validators.required, Validators.email]),
      password: new FormControl(null, [Validators.required, Validators.minLength(6)]),
    });

    if (this.token) this.store.dispatch(UserActions.setAccessToken({ accessToken: this.token }));
  }

  public toggleShowPassword(): void {
    this.showPassword = !this.showPassword;
  }

  public requestPasswordResetLink(): void {
    this.store.dispatch(UserActions.requestResetPassword({ email: this.form.value.email }));
  }

  public resetPassword(): void {
    this.store.dispatch(UserActions.resetPassword({ passwordDto: { password: this.form.value.password } }));
  }
}
